import { render, staticRenderFns } from "./HeadlineCommentList.vue?vue&type=template&id=969aae96&"
import script from "./HeadlineCommentList.vue?vue&type=script&lang=js&"
export * from "./HeadlineCommentList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports